import styled from 'styled-components';
import { getThemeByPath } from '~/utils';
import Typography from '../Typography';

const defaultBtnHeight = 80;
const defaultBtnWidth = 448;

const secondaryMain = getThemeByPath('colors.secondary.main');

const mediumSpacing = getThemeByPath('spacings.medium');

const bkpTablet = getThemeByPath('breakpoints.tablet');

export const ButtonWrapper = styled.button`
  height: ${defaultBtnHeight}px;
  width: ${defaultBtnWidth}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${secondaryMain};
  border-radius: ${defaultBtnHeight / 2}px;

  @media (max-width: ${bkpTablet}px) {
    padding: ${mediumSpacing}px;
    width: 100%;
    height: fit-content;
  }
`;

export const ButtonText = styled(Typography).attrs({
  variant: 'headline4',
  textColor: 'colors.primary.main',
})``;
